<div class="page-container container-fluid p-3">

  <mat-tab-group>
    <mat-tab label="Price History">
      <mat-card class="mt-2 p-0">
        <app-price-history></app-price-history>
      </mat-card>
    </mat-tab>

  </mat-tab-group>

</div>
